import { Link } from 'react-router-dom';

export default function ServicesCTA() {
  return (
    <section className="py-20 bg-[#2A2A2A]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-xl text-white mb-8">
          Whether you are an owner, investor, property manager, or general contractor, we are ready to discuss your next project.
        </p>
        <Link
          to="/contact"
          className="inline-block bg-[#C5A55A] text-[#1A1A1A] px-10 py-4 rounded-md text-lg font-semibold hover:bg-[#B8984D] transition-colors whitespace-nowrap cursor-pointer"
        >
          Start a New Project
        </Link>
      </div>
    </section>
  );
}